import { Component, OnInit } from '@angular/core';
import { TimingService } from '../apis/timing.service';
import { ActivatedRoute } from '@angular/router';
import { Period } from '../viewModels/period';

@Component({
  selector: 'app-print-teacher-timetable2',
  templateUrl: './print-teacher-timetable2.component.html',
  styleUrls: ['./print-teacher-timetable2.component.css']
})
export class PrintTeacherTimetable2Component implements OnInit {

  
    constructor(private api : TimingService ,private activateRoute: ActivatedRoute) { }
  
    data=[]
    periods = []
    break_id = undefined
    division = this.activateRoute.snapshot.paramMap.get('division');
    id = this.activateRoute.snapshot.paramMap.get('id');
  
    ngOnInit(): void {
      if(!this.division){
        this.division = '1'
      }
  
      if(this.id){
        this.api.printTeacher(this.id , this.division).subscribe(
        (data : any[])=>{
        this.data = data
          console.log(data)
          setTimeout(() => {
            window.print()
          }, 1);
        }
      )
      }else{
this.api.printTeachers2(this.division).subscribe(
        (data : any[])=>{
        this.data = data
          console.log(data)
          setTimeout(() => {
            window.print()
          }, 1);
        }
      )
      }
      
  
      this.api.getHiararchyPeriods()
      .subscribe((data: Period[]) => {
        this.periods = data.filter((x) => x.type == 'session' ).sort((a, b) => a.start_hour > b.start_hour ? 0 : -1);
        this.break_id = data.find((x) => x.type == 'break')?.id
        console.log(this.periods)
      })
    }
}
